import React from 'react';

import { PageLayout } from 'src/core/components';
import { EditPlate } from 'src/components';

export const EditPlatePagePage = () => (
  <PageLayout withBreadCrumbs={false}>
    <EditPlate />
  </PageLayout>
);

EditPlatePagePage.propTypes = {};

export default EditPlatePagePage;
